export var registerComponent = function registerComponent(componentRegistry) {
  return function (_ref) {
    var name = _ref.name,
      component = _ref.component;
    componentRegistry.set(name, component);
  };
};